import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Company, User } from 'app/models';
import { ActivatedRoute } from '@angular/router';
import {
  CompanyService,
  UsersService,
  ChangeBranchesService,
  SnackBarService
} from 'app/services';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil,delay } from 'rxjs/operators';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteBranchDialogComponent } from '../../dialogs/confirm-delete-branch-dialog/confirm-delete-branch-dialog.component';
import { AddBranchDialogComponent } from '../../dialogs';
import { SnackbarType } from 'app/constants/Enums';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import * as tableHelpers from 'app/helpers/tableSelectionHelpers';
import { branchAlphaNumericSort } from 'app/helpers/branchAlphaNumericSortHelper';
import { GringottsConstants } from 'app/helpers/constants';
import { environment } from 'environments/environment';


@Component({
  standalone: false,
  selector: 'app-user-branch',
  templateUrl: './user-branch.component.html',
  styleUrls: ['./user-branch.component.scss']
})
export class UserBranchComponent implements OnInit, OnDestroy {
  company: Company;
  companyUsers = [];
  branches = [];
  error: string;
  user: any[];
  branchList: any[];
  selectedToDelete: any;
  companyInitials: string;
  queryString: string;
  loading: boolean;
  noRecordFound = false;
  message = 'No_Companies_Found';
  header: string = '';
  closedBranchStatus ="Inactive";
  private onDestroy$ = new Subject<void>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  branchesDataSource =  new MatTableDataSource([]);
  selection = new SelectionModel<Company>(true, []);
  currentPageBranches: Company[];
  displayedColumns = [
    'select',
    'name',
    'address',
    'sectorNumber',
    'location'
  ];

  constructor(
    private _route: ActivatedRoute,
    private _translateService: TranslateService,
    private _companyService: CompanyService,
    private _usersService: UsersService,
    public _location: Location,
    private _dialog: MatDialog,
    public _changeBranchesService: ChangeBranchesService,
    private _snackbarService: SnackBarService
  ) {}

  ngOnInit() {
    this._companyService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => {
        this.error = error;
      });

    combineLatest([
      this._companyService.company$.pipe(takeUntil(this.onDestroy$)),
      this._usersService.companyUsers$.pipe(takeUntil(this.onDestroy$)),
      this._companyService.branchesUsers$.pipe(takeUntil(this.onDestroy$))
    ])
      .pipe(delay(300))
      .subscribe(([company, companyUsers, branchesUsers]) => {
        this.company = company;
        this._parseName();
        this.companyUsers = companyUsers;
        this.user = this.companyUsers.find(
          (user: User) => user['id'] === this._route.snapshot.params.id
        );
        if (this.user) {
         this.setHeader(this.user);
        }

        if (this.company && this.companyUsers && this.user) {
          let branches: any[] = [];
          if(!this.user['branchAssignments'] || this.user['branchAssignments'].length === 0){
            this.user['branchAssignments'] = [];
            branchesUsers.forEach(branch => {
              if(branch.users.find(user => user.userId === this.user['id'])){
                this.user['branchAssignments'].push(branch.branchId);
              }
            })

          }
          this.user['branchAssignments'].forEach(branchId => {
            const branch = this.company.branches.find(
              (companyBranch: Company) => companyBranch.accountId === branchId
            );
            branches.push(branch);
          });
          branches.sort(branchAlphaNumericSort);
          const headQuarters = branches.filter((companyBranch: Company) => companyBranch.parentAccountId === '')
          if(headQuarters.length > 0){
            branches = branches.filter((companyBranch: Company) => companyBranch.parentAccountId !=='')
            branches.unshift(...headQuarters);
          }
          this.branches = branches;
          this.branchList = branches;
          this.branchesDataSource.data = this.branches;
          this.branchesDataSource.paginator = this.paginator;
          this.branchesDataSource
          .connect()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((branchesList) => {
            this.currentPageBranches = branchesList;
          });
        }
      });
  }


  isAllSelected = () => tableHelpers.isAllSelected(this.currentPageBranches, this.selection.selected);

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle = () => tableHelpers.masterToggle(this.currentPageBranches, this.selection);

  isPartiallySelected = () => tableHelpers.isPartiallySelected(this.currentPageBranches, this.selection.selected);

  ngOnDestroy() {
    this.branches = [];
    this.branchList = [];
    this.onDestroy$.next();
  }

  getBranch(): void {
    if (this.user) {
      const branches: any[] = [];
      this.user['branchAssignments'].forEach(branchId => {
        const branch = this.company.branches.find(
          (companyBranch: Company) => companyBranch.accountId === branchId
        );
        branches.push(branch);
      });
      this.branches = branches;
      this.branchList = branches;
    }
  }

  private _parseName() {
    try {
      if (!this.company.name) {
        throw new Error(
          'UserBranchComponent._ParseName() [Error] Company Not Loaded yet'
        );
      }
      this.companyInitials = `${this.company.name[0].toUpperCase()}${this.company.name[
        this.company.name.length - 1
      ].toUpperCase()}`;
    } catch (exception) {}
  }

  parseLocation(companiesBranches) {
    companiesBranches.forEach(compBranch => {
      compBranch.location = compBranch.city + ', ' + compBranch.state;
    });
    return companiesBranches;
  }

  getUsers() {
    this._usersService.companyUsers$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(users => {
        const routeUser = users.find(
          (user: User) => user['id'] === this._route.snapshot.params.id
        );
        this.user = routeUser;
        this.setHeader(this.user);
      });
    this._usersService.error$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(error => (this.error = error));
  }

  selectedRecords(event) {
    this.selectedToDelete = event;
  }

  setHeader(user){
    if (user) {
      this.header = `${user['name']}`;
      if(user['country'] && !this.isEqual(user['country'], GringottsConstants.notAvailable)){
        this.header += `, ${user['country']}`
      }
      if(user['stateProvince'] && !this.isEqual(user['country'], GringottsConstants.notAvailable)){
        this.header += `, ${user['stateProvince']}`
      }
    }
  }

  removeBranches() {
    let title;
    this._translateService
      .get('COMPANY_DELETE_USERS.delete_users_company_confirmation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(value => (title = value));
    if (this.selection.selected.length === 0) {
      let removeBranch;
      let removeBranchDescription;
      this._translateService
        .get('COMPANY.remove_branch')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (removeBranch = value));
      this._translateService
        .get('COMPANY.not_selected')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (removeBranchDescription = value));
      this._snackbarService.showSnackbar(
        SnackbarType.info,
        removeBranch,
        removeBranchDescription
      );
      return;
    } else {
      let btnText = '';
      this._translateService
        .get('Remove')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => (btnText = value));
      const dialog = this._dialog.open(ConfirmDeleteBranchDialogComponent, {
        width: '670px',
        disableClose: true,
        autoFocus: false,
        data: {
          users: this.selection.selected,
          buttonText: btnText,
          title
        }
      });

      dialog.afterClosed().subscribe(result => {
        if (result) {
          const branchIds = this.selection.selected.map(e => e.accountId);
          if (branchIds) {
            branchIds.forEach(branchId => {
              const branchIndex: number = this.user[
                'branchAssignments'
              ].findIndex(branch => branch === branchId);
              if (branchIndex !== -1) {
                this.user['branchAssignments'].splice(branchIndex, 1);
              }
            });
            this._changeBranchesService.updateUserBranches([this.user], this.company.companyId);
          }
          this.selection.clear();
        }
      });
    }
  }

  handleAddClick(): void {
    const dataNotLoaded = !Boolean(this.user && this.company);
    this.addBranches();
  }

  addBranches(): void {
    if (this.company) {
      // translate strings
      let addBranchMessage;
      this._translateService
        .get('USER_BRANCHES_DIALOG.all_branches_assigned')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (addBranchMessage = value));
      let title;
      this._translateService
        .get('USER_BRANCHES_DIALOG.add_branches_title')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (title = value));
      let warning = '';
      this._translateService
        .get('SNACKBAR.warning')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(value => (warning = value));

      const branchesNotassignedToUser = this.getBranchesNotAssignedToUser();
      if (branchesNotassignedToUser.length === 0) {
        this._usersService._snackbarService.showSnackbar(
          SnackbarType.info,
          'Info',
          addBranchMessage
        );
        return;
      }

      const dialog = this._dialog.open(AddBranchDialogComponent, {
        disableClose: true,
        autoFocus: true,
        width:'700px',
        height:'600px',
        data: {
          title,
          branches: branchesNotassignedToUser,
          user: this.user
        }
      });

      dialog.afterClosed().subscribe(result => {
        if (result) {
          const selectedBranchesIds = this._changeBranchesService.getBranches().map(b => b.accountId);
          if (selectedBranchesIds.length > 0) {
            const accountId = this.company.companyId;
            this._changeBranchesService.updateUserBranches(
              [this.user],
              accountId,
            );
          }
        }
      });
    }
  }

  getBranchesNotAssignedToUser(): Company[] {
    if (this.user) {
      return this.company.branches.filter(
        branch => !this.user['branchAssignments'].includes(branch.accountId) && !this.isEqual(branch.status , this.closedBranchStatus)
      );
    } else {
      return this.company.branches;
    }
  }

  isEqual(value1 : string, value2: string) : boolean{
    if(!value1 || !value2) return false;
    return value1.toLocaleLowerCase() === value2.toLocaleLowerCase();
  }

  monitorSearch(search: string) {
    this.queryString = search.trim();
    if (this.queryString.trim().length >= Number(environment.minimumSearchLength)) {
      this.branches = this.branchList.filter(a =>
        a['name'].toUpperCase().includes(this.queryString.toUpperCase().trim()) ||
        a['sectorNumber'].includes(this.queryString.toUpperCase().trim())
      );
      this.noRecordFound = this.branches.length === 0;
    } else {
      this.branches = this.branchList;
      this.noRecordFound = false;
    }
    this.branchesDataSource.data = this.branches;
    setTimeout(() => {
      this.branchesDataSource.paginator = this.paginator;
    }, 10);
  }
}
